<template>
  <div class="page-attend">
    <h1 class="title">
      我参与的讲坛：
    </h1>

    <p style="text-align: left;">
      听课证明将会在讲座结束后的三个工作日内上传
    </p>

    <el-table :data="attends" border stripe>
      <el-table-column label="姓名" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="学号" align="center">
        <template slot-scope="scope">
          {{ scope.row.code }}
        </template>
      </el-table-column>
      <el-table-column label="月" align="center">
        <template slot-scope="scope">
          {{ scope.row.month }}
        </template>
      </el-table-column>
      <el-table-column label="日" align="center">
        <template slot-scope="scope">
          {{ scope.row.day }}
        </template>
      </el-table-column>
      <el-table-column label="讲座名称" align="center">
        <template slot-scope="scope">
          {{ scope.row.attendName }}
        </template>
      </el-table-column>
      <el-table-column label="是否属于" align="center">
        <template slot-scope="scope">
          {{ scope.row.shuyu ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="年级" align="center">
        <template slot-scope="scope">
          {{ scope.row.year }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="download(scope.row)"
            :loading="loading"
          >
            下载证书
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <template v-if="qnattends.length">
      <h1 class="title">
        我参与的青年大学习：
      </h1>

      <el-table :data="qnattends" border stripe>
        <el-table-column label="学号" align="center">
          <template slot-scope="scope">
            {{ scope.row.code }}
          </template>
        </el-table-column>
        <el-table-column label="期数" align="center">
          <template slot-scope="scope">
            {{ scope.row.qi }}
          </template>
        </el-table-column>
        <el-table-column label="季数" align="center">
          <template slot-scope="scope">
            {{ scope.row.ji }}
          </template>
        </el-table-column>
        <el-table-column label="截止日期" align="center">
          <template slot-scope="scope">
            {{ scope.row.date }}
          </template>
        </el-table-column>
        <el-table-column label="核销码" align="center">
          <template slot-scope="scope">
            {{ scope.row.ma }}
          </template>
        </el-table-column>
        <el-table-column label="优惠" align="center">
          <template slot-scope="scope">
            {{ scope.row.youhui }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click.stop="qndownload(scope.row)"
              :loading="loading"
            >
              下载证书
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <div class="logout">
      <el-button type="danger" @click.stop="logout">退出登录</el-button>
    </div>
  </div>
</template>

<script>
import { HttpClient, baseURL } from "../util/http";
export default {
  data() {
    return {
      attends: [],
      qnattends: [],
      loading: false,
    };
  },
  created() {
    if (this.$route.query.token) {
      localStorage.lzjttokenv2 = this.$route.query.token;
    }
    if (!localStorage.lzjttokenv2) {
      location.href = `${baseURL}/jaccount/auth`;
      return;
    }
    HttpClient.get("/attend/my", {
      token: localStorage.lzjttokenv2,
    }).then((res) => {
      this.attends = res;
    });

    HttpClient.get("/qnattend/my", {
      token: localStorage.lzjttokenv2,
    }).then((res) => {
      this.qnattends = res;
    });
  },
  methods: {
    async download(item) {
      try {
        this.loading = true;
        let res = await HttpClient.get("/attend/pdf", {
          id: item._id,
        });
        location.href = res;
      } finally {
        this.loading = false;
      }
    },
    async qndownload(item) {
      try {
        this.loading = true;
        let res = await HttpClient.get("/qnattend/pdf", {
          id: item._id,
        });
        location.href = res;
      } finally {
        this.loading = false;
      }
    },
    logout() {
      localStorage.removeItem("lzjttokenv2");
      this.$router.replace("/home");
    },
  },
};
</script>

<style scoped lang="less">
.page-attend {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 10px;
  min-height: calc(100vh - 300px);
  .title {
    text-align: left;
  }
  .logout {
    text-align: left;
    margin-top: 20px;
  }
}
</style>
